module.exports = __webpack_public_path__ + "img/icon-info.91d6523e.svg";